/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { Link } from 'react-resource-router';

import { token } from '@atlaskit/tokens';

export const CreatePullRequestLink = styled.a({
  '&, &:hover, &:focus': {
    color: token('color.link'),
  },
});

export const CreatePullRequestClientLink = styled(Link)({
  '&, &:hover, &:focus': {
    color: token('color.link'),
  },
});
